import React from 'react';
import Items from './Items';
import OrderForm from './Form';
import { Row, Col, Spin } from 'antd';
import { withCookies } from 'react-cookie';
import { navigate } from '@reach/router';
import ShopMenu from './ShopMenu'
import { fetchEshopData } from '../enums/fetchData'

class Dashboard extends React.Component {
    state = {
        shopping: {},
        total: 0,
        selectedItem: "beerItems",
        eshopData: null,
        loading: true,
    };

    async componentDidMount() {
        const { cookies } = this.props
        if (cookies.get('confirmed18') === 'underage') {
            navigate('/underage')
        }
        const data = await fetchEshopData();
        this.setState({ eshopData: data, loading: false });
    }

    addItem = (item, target, data) => {
        let { shopping } = this.state

        shopping[item] = { "items": target, "total": target * data.price, "shortLabel": data.shortLabel }
        const total = Object.entries(shopping).map(el => el[1].total).reduce((a, b) => a + b, 0)

        this.setState({
            shopping,
            total: total
        })
    }


    setSelecetdItem = (e) => {
        this.setState({ selectedItem: e })
    }

    render() {
        const { selectedItem, eshopData, loading } = this.state

        if (loading || !eshopData) {
            return <div style={{ paddingTop: 50, textAlign: 'center' }}><Spin size="large" /></div>
        }

        return (
            <div style={{ paddingTop: 50 }}>

                <ShopMenu selectedItem={selectedItem} setSelecetdItem={this.setSelecetdItem} />
                <Row gutter={[8, 8]}>

                    <Col xs={24} md={16} lg={16} xl={16} xxl={16}>
                        <Items
                            addItem={this.addItem} items={eshopData[selectedItem].filter(el => el.active)}
                            eshopData={eshopData}
                        />

                    </Col>

                    <Col xs={24} md={8} lg={8} xl={8} xxl={8}>
                        <Row>
                            <p>Vážení příznivci Břevnovského klášterního pivovaru,</p>
                            <p>Děkujeme, že odebíráte naše pivo, že vám chutná a že si jím zpříjemňujete chvíle běžného života. Proto se snažíme vyjít vaším požadavkům co nejvíc vstříc a realizujeme každý čtvrtek (vyjma státních svátků) rozvoz našich piv po Praze 5, 6 a 7, tedy kolem našeho komína</p>
                            <p>Pokud se v těchto lokacích nenacházíte, napište nám prosím do poznámky, že byste chtěli pivo třeba poslat. My vám pošleme celkovou nabídku, která bude zahrnovat balení a především dopravu. Na základě této nabídky nám poté můžete nabídku potvrdit či odmítnout.</p>
                            <p>Pro případy odeslání piva mimo náš rozvozový rádius doporučujeme objednávat pivo v počtech kusů 6,12,18,24 ks. Usnadní to proces balení do kartonů.</p>
                            <br />
                            <p>Tak vám všem, Dej bůh štěstí!<br />
                                Ing. Aleš Potěšil, sládek pivovaru</p>

                        </Row>
                        <OrderForm orderData={this.state} eshopData={eshopData} />
                    </Col>
                </Row>

            </div>

        )
    }
}

export default withCookies(Dashboard)
